









import {ElementMixin} from 'vue-slicksort';

export default {
    name: 'BaseSortableItem',
    components: {},
    props: {
    },
    data() {
        return {};
    },
    mixins: [ElementMixin],
    methods: {},
};
